import allStatesAndFips from 'shared/constants/mortgage/allStatesAndFips.json';

/**
 *
 * @param {String} county
 * @param {String} state
 * @returns {String} fipCode
 */
const countyToFipCode = (county, state) => allStatesAndFips[state][county];

export default countyToFipCode;
